import React, { useState } from 'react';
import '../styles/faqs.scss';

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      id: 1,
      question: "What is AstroVansh?",
      answer: "AstroVansh is your family's personal astrology partner. We connect you with trusted family astrologers who offer monthly consultations, remedies, and spiritual guidance tailored to each family member's birth chart (kundli)."
    },
    {
      id: 2,
      question: "How is AstroVansh different from other astrology apps?",
      answer: "Unlike typical astrology apps, AstroVansh provides: Personalized weekly guidance for every family member, A dedicated astrologer who understands your family lineage and patterns, Regular follow-ups, rituals, and remedy planning, Option to preserve your family's astrological history."
    },
    {
      id: 3,
      question: "Who are the astrologers on AstroVansh?",
      answer: "All our astrologers are verified experts with years of Vedic astrology practice. Many have served generations and are now accessible online for consistent, authentic advice."
    },
    {
      id: 4,
      question: "How does the monthly subscription work?",
      answer: "You pay a fixed monthly fee for your entire family (up to 6 members). This includes: One-on-one sessions with your family astrologer, Weekly predictions and alerts, Emergency consultations for health, career, or marriage concerns, Astro-remedies planning (puja, gems, mantras, etc.)."
    },
    {
      id: 5,
      question: "Can I change my astrologer later?",
      answer: "Yes, although we recommend continuity, you can switch your astrologer if needed based on availability and preference."
    },
    {
      id: 6,
      question: "Is my personal information and kundli data safe?",
      answer: "Absolutely. We follow strict data privacy policies and store Kundli information securely. Your family's astrological details are never shared without consent."
    },
    {
      id: 7,
      question: "What kind of issues can be discussed with the astrologer?",
      answer: "You can discuss: Marriage, love, and compatibility, Career, job changes, and education, Health warnings and remedies, Childbirth, family disputes, and ancestral issues, Muhurats (auspicious timings) and Vastu advice."
    },
    {
      id: 8,
      question: "Can I gift an AstroVansh subscription to someone?",
      answer: "Yes! AstroVansh makes a thoughtful gift for weddings, baby showers, anniversaries, or simply to ensure someone's well-being. Gifting options are available."
    },
    {
      id: 9,
      question: "What if I don't know the exact time of birth?",
      answer: "No worries! Our expert astrologers can do Prashna Kundli (question-based chart) or guide you through birth time rectification to provide accurate predictions and remedies."
    },
    {
      id: 10,
      question: "Can I have a live video consultation with my astrologer?",
      answer: "Yes. Depending on your subscription tier, you can opt for live video, voice, or chat consultations as per your preference and availability."
    },
    {
      id: 11,
      question: "What is a Family AstroVault?",
      answer: "Our exclusive AstroVault securely stores: Kundlis of all family members, Past predictions & remedies, Ritual records, puja photos, mantras, Future important dates & alerts. This creates a sacred digital history for your Vansh (lineage)."
    },
    {
      id: 12,
      question: "Do you offer emergency consultations?",
      answer: "Yes. You can raise an emergency request (e.g., sudden illness, legal concern, accident alert) and receive astrological insights within an hour. (premium plans only)."
    },
    {
      id: 13,
      question: "What remedies do you suggest? Will I be forced to buy gemstones or rituals?",
      answer: "We offer authentic Vedic remedies—mantras, donations, fasting, gemstones, pujas, and meditation. However, you're never forced to buy. All remedies are optional and based on your comfort and belief."
    },
    {
      id: 14,
      question: "Is there a mobile app for AstroVansh?",
      answer: "Yes! The AstroVansh app is available on Android and iOS. You can access your astrologer, kundli updates, monthly alerts, and remedies directly through the app."
    },
    {
      id: 15,
      question: "Can I subscribe for only one person instead of the whole family?",
      answer: "Yes. While AstroVansh is built for families, you can opt for an individual plan if you need solo guidance."
    },
    {
      id: 16,
      question: "How frequently will I get updates or predictions?",
      answer: "You will receive: Weekly prediction reports, Fortnightly tips and dos/don'ts, Special alerts for eclipses, retrogrades, and dosha periods, Muhurat updates for important events."
    },
    {
      id: 17,
      question: "Can the astrologer guide me on spiritual progress or past life karma?",
      answer: "Yes. Our senior astrologers can help explore: Past life karmas, Spiritual inclinations, Karmic blocks, Personalized sadhanas or rituals to dissolve karmic baggage."
    },
    {
      id: 18,
      question: "How do I cancel or pause my subscription?",
      answer: "You can cancel or pause anytime from your dashboard or app settings. We'll retain your data securely so you can resume later without loss."
    },
    {
      id: 19,
      question: "Can I talk to my astrologer in my regional language?",
      answer: "Yes. AstroVansh supports astrologers fluent in Hindi, English, Tamil, Telugu, Marathi, Bengali, and more. Language preference can be set during onboarding."
    },
    {
      id: 20,
      question: "How does AstroVansh help during family problems or crises?",
      answer: "Your family astrologer acts as a spiritual advisor—offering: Conflict resolution through planetary analysis, Healing rituals for peace at home, Timely caution on legal or medical issues, Astrological explanation of recurring family patterns."
    },
    {
      id: 21,
      question: "Can I connect my family astrologer with my priest or family guru?",
      answer: "Yes, if you wish, we can coordinate with your existing religious guide to align astrology with rituals for better harmony and impact."
    },
    {
      id: 22,
      question: "Do you provide vastu consultation as part of the plan?",
      answer: "Yes. Select plans include online vastu consultations for your home, workplace, or plot—with suggestions for corrections and spiritual balance."
    },
    {
      id: 23,
      question: "What is the deeper vision behind AstroVansh?",
      answer: "AstroVansh is not just about predictions. It's about restoring the ancient Indian tradition where every family had a spiritual guide—a kul-guru or raj-jyotishi. We are bringing that trust, legacy, and wisdom into the digital age for your Vansh."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="title">
          <h2>FAQ's</h2>
        </div>
        
        <div className="faq-container">
          {faqData.map((faq, index) => (
            <div 
              key={faq.id}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div 
                className="faq-question"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{faq.question}</h3>
                <div className="faq-icon">
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none"
                    className={`chevron ${activeIndex === index ? 'rotated' : ''}`}
                  >
                    <path 
                      d="M6 9L12 15L18 9" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              
              <div className="faq-answer">
                <div className="faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqs;